export const ACCESS_TOKEN = "token";
export const REFRESH_TOKEN = "refresh_token";
export const TWOFA = "2FA";
export const R_ACCESS_TOKEN = "r_token";
export const R_REFRESH_TOKEN = "r_refresh_token";
export const T_ACCESS_TOKEN = "t_token";
export const T_REFRESH_TOKEN = "t_refresh_token";
export const REFERER = "referer";
export const URL_PARAMS = "url_params";

let envProd = null;
// let isTradingClient = false;

export function setTokens(accessToken, refreshToken) {
  let accessTokenKey = R_ACCESS_TOKEN, refreshTokenKey = R_REFRESH_TOKEN;
  let tokenDetails = JSON.parse(atob(accessToken.split(".")[1]));
  if (tokenDetails && tokenDetails.isTradingClient) {
    accessTokenKey = T_ACCESS_TOKEN;
    refreshTokenKey = T_REFRESH_TOKEN;
  }
  setCookieNew(accessTokenKey, accessToken);
  setCookieNew(refreshTokenKey, refreshToken);
}

export function getToken(isAccessToken) {
  return isAccessToken
    ?
    getCookie(R_ACCESS_TOKEN) || getCookie(T_ACCESS_TOKEN) || ""
    :
    getCookie(R_REFRESH_TOKEN) || getCookie(T_REFRESH_TOKEN) || "";
}

export function deleteTokens() {
  deleteCookie(R_ACCESS_TOKEN);
  deleteCookie(R_REFRESH_TOKEN);
  deleteCookie(T_ACCESS_TOKEN);
  deleteCookie(T_REFRESH_TOKEN);
  deleteCookie(TWOFA);
}

export function set2FA(twoFA) {
  setCookieNew(TWOFA, twoFA);
}

export function get2FA() {
  return getCookie(TWOFA);
}

export function setReferer() {
  // let referer = window.location.href.split("?referer=")[1];
  const addr = new URL(window.location.href);
  let urlParams = addr.searchParams.toString();
  const ref = addr.searchParams.get("referer");
  if (ref) {
    setCookieNew(REFERER, ref);
  }
  if (urlParams) {
    setCookieNew(URL_PARAMS, urlParams);
  }
}

export function getReferer() {
  return getCookie(REFERER);
}

export function isCTCL() {
  let referer = atob(getReferer());
  // alert(referer);
  return referer.indexOf('ctcladmin') !== -1 || referer.indexOf('beta-next.tradebulls.in') !== -1;
}

export function setCookie(cname, cvalue, expiry, path, domain) {
  var expires = "max-age=" + expiry;
  var dm = domain ? "domain=" + domain : ""
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=" + path + ";" + dm;
}

export function getCookie(cName) {
  var name = cName + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function setCookieNew(cName, cValue) {
  if (!isProd()) {
    //Dev
    document.cookie = cName + "=" + cValue + ";path=/";
  } else {
    //Prod
    document.cookie = cName + "=" + cValue + ";path=/;secure;domain=tradebulls.in";
  }
}

export function deleteCookie(cName) {
  var d = new Date();
  d.setTime(d.getTime() - 500);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cName + "=" + "" + ";" + expires + ";path=/" + (isProd() ? ";secure;domain=tradebulls.in" : "");
}

function isProd() {
  if (envProd == null) {
    envProd = process.env && process.env.NODE_ENV && process.env.NODE_ENV === 'production';
  }
  return envProd;
}

export function getUrlParamValue(key) {
  let param = String(getCookie('url_params'))?.split('&')?.find(ele => ele.includes(key)) || "";
  return param?.split("=")[1] || ''
}

export default getCookie;